import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Address from './components/Address';
import SpecialPoojas from './components/SpecialPoojas';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
// import ContactTime from './components/ContactTime';

function App() {
  return (
<div>
  <Navbar/>
  <Home/>
  <Address/>
  {/* <ContactTime/> */}
  <SpecialPoojas/>
  <ContactForm/>
  <Footer/>
</div>
  );
}

export default App;
